// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"1cface10","453":"9cdd869e","454":"7fcf1279","702":"7b833d08"}[chunkId] + ".chunk.js";
};